<template>
  <div>
    <v-col cols="12" v-if="informText != ''">
      <v-alert type="error">{{ informText }}</v-alert>
    </v-col>

    <v-data-table
      :headers="headers"
      :items="packageData"
      class="elevation-1"
      :loading="loading"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            @click="dialogPackageCreate = !dialogPackageCreate"
            v-if="roles.create_package"
            >Add Package</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.tracking_numbers="{ item }">
        <div v-for="(i, index) of item.tracking_numbers" :key="index">
          {{ i.tracking_number }} - {{ i.carrier }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          x-small
          @click="
            selectedPackage = item._id;
            dialogPackageDetail = !dialogPackageDetail;
          "
          v-if="roles.read_package"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn color="primary" x-small v-else disabled>
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <BaseDialog :active.sync="dialogPackageDetail" dialog_name="Package Detail">
      <PackageDetail
        :packageID="selectedPackage"
        :supplierData="supplierData"
      />
    </BaseDialog>

    <BaseDialog :active.sync="dialogPackageCreate" dialog_name="Package Create">
      <PackageCreate :supplierData="supplierData" />
    </BaseDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
import PackageDetail from "./c-dialog-package-detail.vue";
import PackageCreate from "./c-dialog-package-create.vue";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PackageList",

  components: {
    BaseDialog,
    PackageDetail,
    PackageCreate,
  },

  created() {
    this.$root.$refs.packageList = this;
  },

  data: () => ({
    loading: false,
    search: "",
    packageData: [],
    supplierData: [],
    roles: [],
    error: null,
    showBtn: false,
    informText: "",

    dialogPackageDetail: false,
    dialogPackageCreate: false,

    headers: [
      {
        text: "Package Name",
        align: "start",
        value: "package_name",
      },
      // { text: 'Site Manager', value: 'manager_name' },
      { text: "Total Quantity", value: "total_quantity" },
      { text: "Sold", value: "sold" },
      { text: "Product Groups", value: "product_groups" },
      { text: "Supplier", value: "supplier" },
      { text: "Basecost", value: "base_cost" },
      { text: "Tracking Number", value: "tracking_numbers" },
      { text: "Status", value: "status" },
      { text: "Created Time", value: "created_time" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    selectedPackage: "",
  }),

  methods: {
    async loadData() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "package-loadData"
      );
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "packages", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.packageData = response.data.data.packages;
              this.supplierData = response.data.data.suppliers;
              this.packageData.filter(
                (t) =>
                  (t.created_time = moment(t.created_time).format(
                    "YYYY-MM-DD HH:MM:SS"
                  ))
              );
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log("currentSession user-loadData-undefined: ", currentSession);
      }

      this.loading = false;
    },

    turnOffDialog(reload) {
      console.log("package list: ", reload);
      this.dialogPackageDetail = false;
      this.dialogPackageCreate = false;

      if (reload) {
        this.loadData();
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("package");
    if (this.roles.list_packages) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>